export const FileTypes = {
  IMAGE: 'image',
  DOCUMENT: 'document',
  DOCS: 'docs',
};
